import { useEffect, useState } from "react";
import "./Chest.css";
import { MdSearch } from "react-icons/md";
import {
  getAllChests,
  deleteChest,
  toggleChestStatus,
  createChest,
} from "../../api/chestApi";

import ConfirmationModal from "../MiniComponents/ConfirmationModal";

export default function Chest() {
  const [searchText, setSearchText] = useState("");
  const [openActionId, setOpenActionId] = useState(null);
  const [loading, setLoading] = useState(false);

  const [chests, setChests] = useState([]);
  const [selectedChest, setSelectedChest] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  /* ================= FETCH CHESTS ================= */
  const fetchChests = async () => {
    try {
      setLoading(true);
      // const res = await getAllChests();
      const res = await getAllChests();
      setChests(res?.data || []);
    } catch (err) {
      console.error("Failed to fetch chests:", err);
      setChests([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchChests();
  }, []);

  /* ================= SEARCH ================= */
  // const filteredChest = chests.filter((c) =>
  //   c?.name.toLowerCase().includes(searchText.toLowerCase()),
  // );

  /* ================= ACTIONS ================= */
  const handleView = (chest) => {
    setSelectedChest(chest);
    setOpenActionId(null);
  };

  const handleDelete = async (id) => {
    try {
      await deleteChest(id);
      setChests((prev) => prev.filter((c) => c._id !== id));
      setDeleteId(null);
    } catch (err) {
      console.error("Delete failed:", err);
    }
    setOpenActionId(null);
  };

  const handleToggleStatus = async (chest) => {
    try {
      const newValue = !chest.active;
      await toggleChestStatus(chest._id, newValue);
      setChests((prev) =>
        prev.map((c) => (c._id === chest._id ? { ...c, active: newValue } : c)),
      );
    } catch (err) {
      console.error("Status update failed:", err);
    }
  };

  const handleBack = () => {
    setSelectedChest(null);
  };

  const handleCreateChest = async (payload) => {
    try {
      await createChest(payload);
      fetchChests();
      setSelectedChest(null);
    } catch (err) {
      console.error("Create chest failed:", err);
    }
  };

  const handleUpdateChest = async (payload) => {
    try {
    } catch (error) {
      console.error("error on update chest:", error);
    }
  };

  return (
    <div className="chest-container">
      {/* HEADER */}
      <div className="chest-header">
        <div className="search-chest">
          <div className="search-box-chest">
            <MdSearch className="icon" />
            <input
              type="text"
              placeholder="Search for anything"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
        </div>

        <div className="chest-header-left chestleft">
          <h2>Chest</h2>
          <p>Awesome subscription kits to make game play more engaging</p>
        </div>
      </div>

      {selectedChest ? (
        <ChestForm
          chest={selectedChest}
          onBack={handleBack}
          onSubmit={handleCreateChest}
        />
      ) : (
        <div className="chest-main">
          <div className="chest-table-wrapper">
            <table className="chest-table">
              <thead>
                <tr>
                  <th>
                    <input type="checkbox" />
                  </th>
                  <th>SRN</th>
                  <th>Chest Name</th>
                  <th>Price</th>
                  <th>Ads Count</th>
                  <th>Coins</th>
                  <th>Usage</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {loading && (
                  <tr>
                    <td colSpan="9" align="center">
                      Loading...
                    </td>
                  </tr>
                )}

                {!loading &&
                  chests.map((c, index) => (
                    <tr key={c._id}>
                      <td>
                        <input type="checkbox" />
                      </td>
                      <td>{index + 1}</td> {/* ✅ SRN FIX */}
                      <td>{c?.chestType}</td>
                      <td>{c?.chestPrice}</td>
                      <td>{c?.adCount}</td>
                      <td>{c?.coins}</td>
                      <td>{c?.usage}</td>
                      <td>
                        <span
                          className={
                            c.active
                              ? "chest-status chest-status-active"
                              : "chest-status chest-status-inactive"
                          }
                          onClick={() => handleToggleStatus(c)}
                        >
                          {c.active ? "active" : "inactive"}
                        </span>
                      </td>
                      <td className="chest-action-cell">
                        <button
                          className="chest-dots-btn"
                          onClick={() =>
                            setOpenActionId(
                              openActionId === c._id ? null : c._id,
                            )
                          }
                        >
                          ...
                        </button>

                        {openActionId === c._id && (
                          <div className="chest-action-menu">
                            <button onClick={() => handleView(c)}>View</button>
                            <button
                              onClick={() => {
                                setDeleteId(c._id);
                                setOpenActionId(null);
                                // handleDelete(c._id)
                              }}
                            >
                              Delete
                            </button>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}

                {!loading && chests.length === 0 && (
                  <tr>
                    <td colSpan="9" align="center">
                      No chests found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {deleteId && (
        <ConfirmationModal
          title="Are you sure want to delete?"
          onCancel={() => {
            setDeleteId(null);
          }}
          onConfirm={() => {
            handleDelete(deleteId);
          }}
        />
      )}
    </div>
  );
}

/* ================= CHEST FORM ================= */

function ChestForm({ chest, onBack, onSubmit }) {
  const [form, setForm] = useState({
    name: chest.name || "",
    price: chest.price || 0,
    adCount: chest.adCount || 0,
    coins: chest.coins || 0,
    snakes: chest.snakes || [],
    powerUps: chest.powerUps || [],
    usage: chest.usage || 0,
    active: chest.active ?? true,
  });

  const updateField = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <div className="chest-form-main">
      <div className="chest-form-card">
        <div className="chest-form-header-row">
          <h3>Add Details</h3>
          <button className="chest-form-back-btn" onClick={onBack}>
            Back
          </button>
        </div>

        <div className="chest-form-group">
          <label>Chest Name</label>
          <input
            value={form.name}
            onChange={(e) => updateField("name", e.target.value)}
          />
        </div>

        <div className="chest-form-group">
          <label>Price</label>
          <input
            type="number"
            value={form.price}
            onChange={(e) => updateField("price", +e.target.value)}
          />
        </div>

        <div className="chest-form-group">
          <label>Ads</label>
          <input
            type="number"
            value={form.adCount}
            onChange={(e) => updateField("adCount", +e.target.value)}
          />
        </div>

        <div className="chest-form-group">
          <label>Coins</label>
          <input
            type="number"
            value={form.coins}
            onChange={(e) => updateField("coins", +e.target.value)}
          />
        </div>

        <button className="chest-form-back-btn" onClick={() => onSubmit(form)}>
          Save Chest
        </button>
      </div>
    </div>
  );
}
